import React, { Component, Fragment } from 'react';

import { Panel } from 'components/panel';
import { translate } from 'components/translate';
import { generateId } from 'modules/content/helper';
import PropTypes from 'prop-types';

import { ChecklistItem, Checklist } from '../checklist';

import './PanelCheckList.scss';

@translate()
class PanelCheckList extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    className: PropTypes.string,
    name: PropTypes.string,
    panelTitle: PropTypes.string,
    panelSubHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    checkListHeader: PropTypes.func,
    value: PropTypes.array,
    loading: PropTypes.bool,
    t: PropTypes.func,
    formatItems: PropTypes.func,
    disabled: PropTypes.bool,
    formatItem: PropTypes.func,
    formatSubheader: PropTypes.func
  };

  static defaultProps = {
    value: []
  };

  state = {
    loading: false
  };

  constructor(props) {
    super(props);

    this.state = {
      checklistId: generateId(),
      loading: this.props.loading
    };
  }

  static getDerivedStateFromProps(props, state) {
    return props.loading !== state.loading ? { loading: props.loading } : null;
  }

  get formattedItems() {
    const { value, formatItems } = this.props;

    return formatItems(value);
  }

  get isAllChecked() {
    return this.formattedItems.every((item) => item.checked);
  }

  handleSelectAll = (event) => {
    const { checked } = event.target;

    const newValue = this.formattedItems
      .map((item) => {
        item.checked = checked;
        return item;
      })
      .filter((item) => item.checked)
      .map((item) => item.value);

    this.onChange(newValue);
  };

  handleSingleChange = (event) => {
    this.onChange(event.target.value);
  };

  onChange = (items) => {
    const { onChange, name } = this.props;

    onChange && onChange({ target: { name, value: items } });
  };

  renderSubheader() {
    const { checklistId } = this.state;
    const { name, checkListHeader, t, formatSubheader } = this.props;

    return (
      <Fragment>
        <ChecklistItem
          name={name}
          onChange={this.handleSelectAll}
          className="checklist__item__select__all panelchecklist__checklist__item__select__all"
          id={`checklist__${checklistId}__item__select__all`}
          key={`checklist__${checklistId}__item__select__all`}
          formatItem={formatSubheader}
          item={{
            name: t('general.select_all'),
            value: 'select__all',
            checked: this.isAllChecked
          }}
        />

        {checkListHeader && checkListHeader()}
      </Fragment>
    );
  }

  render() {
    const {
      name,
      panelTitle,
      panelSubHeader,
      formatItem,
      disabled,
      className,
      ...props
    } = this.props;
    const { loading } = this.state;

    return (
      <Panel
        header={panelTitle}
        className={className}
        nopadding={true}
        subHeader={panelSubHeader || this.renderSubheader()}
        loading={loading}
        disabled={disabled}
      >
        <Checklist
          {...props}
          onChange={this.handleSingleChange}
          className="panelchecklist__checklist"
          items={this.formattedItems}
          name={name}
          formatItem={formatItem}
        >
          <Checklist.Items />
        </Checklist>
      </Panel>
    );
  }
}

export default PanelCheckList;
